import { render } from "./TechAndPatent.vue?vue&type=template&id=9afb23c0&scoped=true"
import script from "./TechAndPatent.vue?vue&type=script&lang=js"
export * from "./TechAndPatent.vue?vue&type=script&lang=js"

import "./TechAndPatent.vue?vue&type=style&index=0&id=9afb23c0&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9afb23c0"]])

export default __exports__